import React from 'react';
import { inject, observer } from 'mobx-react';
import {IMaskInput} from 'react-imask';
import { Form, OverlayTrigger, Popover } from 'react-bootstrap';
import { LuInfo } from "react-icons/lu";


@inject('vTerminal', 'global')
@observer
class PaymentMethodECheck extends React.Component {

    constructor(props) {
        super(props);
        this.handleTextChangeACH = this.handleTextChangeACH.bind(this);
        this.handleTextChangeACHSelect = this.handleTextChangeACHSelect.bind(this);
    }

    handleTextChangeACH(field, value) {
        this.props.vTerminal.handleTextChangeACH(field, value);
    }
    
    handleTextChangeACHSelect(e) {
        this.props.vTerminal.handleTextChangeACH(e.target.name, e.target.value);
    }

    isBeforeCutoffTime() {
        // Get current time in ET timezone
        const now = new Date();
        const etOptions = { timeZone: 'America/New_York' };
        const etTime = new Date(now.toLocaleString('en-US', etOptions));
        
        // Create a Date object for today at 2:30 PM ET
        const cutoffTime = new Date(etTime);
        cutoffTime.setHours(14, 30, 0, 0);
        
        // Return true if current time is before 2:30 PM ET
        return etTime < cutoffTime;
    }

    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-sm mb-3">
                        <div className="form-floating">
                            <IMaskInput
                                mask={this.props.global.maskValidator('alphanumericspaces')}
                                data-qaid="accountHolderNameInput"
                                name="achAccountHolderName"
                                defaultValue={this.props.vTerminal.paymentPage.paymentMethods.achAccountHolderName ? this.props.vTerminal.paymentPage.paymentMethods.achAccountHolderName: ''}
                                unmask={true}
                                onAccept={
                                    (value, mask) => this.handleTextChangeACH('achAccountHolderName', value)
                                }
                                placeholder="Account Holder Name"
                                className={this.props.vTerminal.getPaymentPageErrors.paymentMethodsAchAccountHolderNameError ? "form-control input-error" : "form-control" }
                                id="achAccountHolderName"
                            />
                            <label htmlFor="achAccountHolderName">Account Holder Name</label>
                        </div>
                    </div>
                    <div className="col-sm mb-3">
                        <div className="form-floating">
                            <select className={this.props.vTerminal.getPaymentPageErrors.paymentMethodsAchAccountTypeError ? "form-select form-control input-error" : "form-select form-control" } id="achAccountType" name="achAccountType" onChange={(e) => this.handleTextChangeACHSelect(e)} defaultValue={''} data-qaid="accountTypeInput">
                                <option value="">Select...</option>
                                <option value="Checking" data-qaid="selectCheckingAccount">Checking</option>
                                <option value="Savings" data-qaid="selectSavingAccount">Savings</option>
                            </select>
                            <label htmlFor="achAccountType">Account Type</label>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm mb-3">
                        <div className="form-floating">
                            <IMaskInput
                                mask={this.props.global.maskValidator('routing')}
                                data-qaid="achRoutingNumber"
                                name="achRouting"
                                defaultValue={this.props.vTerminal.paymentPage.paymentMethods.achRouting ? this.props.vTerminal.paymentPage.paymentMethods.achRouting: ''}
                                unmask={true}
                                onAccept={
                                    (value, mask) => this.handleTextChangeACH('achRouting', value)
                                }
                                placeholder="Routing #"
                                className={this.props.vTerminal.getPaymentPageErrors.paymentMethodsAchRoutingError ? "form-control input-error" : "form-control" }
                                id="achRouting"
                                inputMode="numeric"
                                pattern="[0-9]*"
                            />
                            <label htmlFor="achRouting">Routing #</label>
                        </div>
                    </div>
                    <div className="col-sm mb-3">
                        <div className="form-floating">
                            <IMaskInput
                                mask={this.props.global.maskValidator('accountnumber')}
                                data-qaid="achAccountNumber"
                                name="achAccount"
                                defaultValue={this.props.vTerminal.paymentPage.paymentMethods.achAccount ? this.props.vTerminal.paymentPage.paymentMethods.achAccount: ''}
                                unmask={true}
                                onAccept={
                                    (value, mask) => this.handleTextChangeACH('achAccount', value)
                                }
                                placeholder="Account #"
                                className={this.props.vTerminal.getPaymentPageErrors.paymentMethodsAchAccountError ? "form-control input-error" : "form-control" }
                                id="achAccount"
                                maxLength={17}
                                inputMode="numeric"
                                pattern="[0-9]*"
                            />
                            <label htmlFor="achAccount">Account #</label>
                        </div>
                    </div>
                </div>
                {this.props.vTerminal.acceptSameDayACH[this.props.vTerminal.isAutopay ? "recurring" : "onetime"] && <div className="row">
                <OverlayTrigger placement="top" {...(this.isBeforeCutoffTime() && {show: false})} overlay={<Popover>
                    <Popover.Content>
                    Same Day ACH is available from 12:00 AM to 2:30 PM ET.
                    </Popover.Content>
                </Popover>}>
                <div className="col-sm" style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <Form.Check
                    type="checkbox"
                    label="Process payment today (Same Day ACH)"
                    id="sameDayACH"
                    name="sameDayACH"
                    disabled={!this.isBeforeCutoffTime()}
                    checked={this.props.vTerminal.sameDayACH}
                    onChange={e => this.props.vTerminal.setSameDayACH(e.target.checked)}
                  />
                  <OverlayTrigger
                    placement="top"
                    {...(!this.isBeforeCutoffTime() && {show: false})}
                    overlay={
                      <Popover>
                        <Popover.Content>
                          Same Day ACH sends your payment today. Payments
                          submitted before 2:30 PM ET are processed the same business
                          day.
                        </Popover.Content>
                      </Popover>
                    }
                  >
                    <LuInfo size={12} style={{ marginBottom: '6px', ...(!this.isBeforeCutoffTime() && { opacity: '50%' })}} />
                  </OverlayTrigger>
                </div>
                </OverlayTrigger>
                
              </div>}
            </div>
        );
    }
}

export { PaymentMethodECheck };